import React, { Component } from "react";
import PropTypes from "prop-types";
import { detect } from "detect-browser";
import axios from "axios";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import CvActionsFooter from "./CvActionsFooter";
import {
  ModalWrapper,
  ModalButton,
  ModalBackDrop,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalTitle,
  ModalBody,
  ModalFooter,
} from "./styles/modal-styles";

library.add(faTimes);

class Modal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modalVisible: false,
      data: null,
    };
  }

  toggleModal = () => {
    const { modalButtonClickEvent } = this.props;

    modalButtonClickEvent();

    this.setState(({ modalVisible }) => ({
      modalVisible: !modalVisible,
    }));
  };

  closeModal = () => {
    this.setState({
      modalVisible: false,
    });
  };

  getCVData = () => {
    const { pdfUrl } = this.props;

    axios.get(pdfUrl).then(({ data }) => {
      this.setState({ data });
    });
  };

  render() {
    const {
      buttonName,
      candidateFooter,
      cvDownloadHandler,
      footer,
      header,
      render,
    } = this.props;
    const { modalVisible, data } = this.state;
    const iOS = detect().name === "ios";

    return (
      <ModalWrapper onClick={() => this.getCVData()}>
        <ModalButton type="submit" id="modalTrigger" onClick={this.toggleModal}>
          {buttonName}
        </ModalButton>
        <ModalBackDrop className={modalVisible && "active"}>
          <ModalContent
            className={modalVisible && "active"}
            iOS={iOS}
            id="modal"
          >
            {header ? (
              <ModalHeader>
                <ModalTitle>{header}</ModalTitle>
                <ModalCloseButton
                  className="closeModal"
                  onClick={this.closeModal}
                >
                  <FontAwesomeIcon icon="times" />
                </ModalCloseButton>
              </ModalHeader>
            ) : (
              <ModalHeader>
                <ModalCloseButton
                  className="closeModal"
                  onClick={this.closeModal}
                >
                  <FontAwesomeIcon icon="times" />
                </ModalCloseButton>
              </ModalHeader>
            )}
            <ModalBody>{render(data)}</ModalBody>
            {candidateFooter ? (
              <ModalFooter>
                <CvActionsFooter cvDownloadHandler={cvDownloadHandler} />
              </ModalFooter>
            ) : (
              <ModalFooter>{footer}</ModalFooter>
            )}
          </ModalContent>
        </ModalBackDrop>
      </ModalWrapper>
    );
  }
}

Modal.propTypes = {
  buttonName: PropTypes.string,
  candidateFooter: PropTypes.bool,
  cvDownloadHandler: PropTypes.func.isRequired,
  footer: PropTypes.string,
  header: PropTypes.string,
  pdfUrl: PropTypes.string.isRequired,
  render: PropTypes.func.isRequired,
  modalButtonClickEvent: PropTypes.func,
};

Modal.defaultProps = {
  buttonName: PropTypes.isNull,
  candidateFooter: PropTypes.isNull,
  footer: PropTypes.isNull,
  header: PropTypes.isNull,
  modalButtonClickEvent: PropTypes.isNull,
};

export default Modal;
